import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { ListAssignedPromotions } from './ListAssignedPromotions';
import SearchBar from './../../components/searchBarComponent/SearchBarComponent';
import { Button, Box } from '@mui/material';
import './AssignedPromotions.css';
import { ComponentAccess } from '../../components/componentAccess/ComponentAccess';
import { rolesMap } from '../../constants/roles-constants';

type AssignedPromotionsInfoProps = {
    campaignData: any,
}

const searchBarDataComponents = {
    helperText: "Search for specific promotion",
    label: "Search by Name,ID,etc...",
    variant: "filled",
    size: "small",
    wrapperClass: 'search-bar-form-control',
    textFieldClass: 'search-bar-assign-promotions-component'
}

const AssignedPromotionsInfo = ({ campaignData }: AssignedPromotionsInfoProps) => {
    const [addPromoDisabled, setAddPromoDisabled] = useState(false);
    const [copyPromoDisabled, setCopyPromoDisabled] = useState(false);
    const [inputText, setInputText] = useState("");
    const [isCopyMode, setIsCopyMode] = useState(false);
    const [assignedPromotionsData, setAssignedPromotionsData] = useState([]);

    useEffect(() => {
        setAddPromoDisabled(moment(campaignData.promotion_end_utc) < moment() || campaignData.archived)
        setCopyPromoDisabled(!!!assignedPromotionsData.length);
    }, [campaignData, assignedPromotionsData])

    const inputHandler = (e: any) => {
        const lowerCase = e.target.value.toLowerCase();
        setInputText(lowerCase);
    };

    return (
        <Box className='componentWrap'>
            <Box className='assign-promotions-wrapper'>
                <ComponentAccess minRole={rolesMap.PromotionManager}>
                    <Button variant="outlined" className={`add-new-promo-button ${addPromoDisabled ? 'disabled' : ''}`} component={Link} to={`/assignPromotion/${campaignData.promotion_id}`} disabled={addPromoDisabled}>Add New Promotion</Button>
                </ComponentAccess>
                <ComponentAccess minRole={rolesMap.PromotionManager}>
                    <Button
                        variant="outlined"
                        className={`add-new-promo-button ${copyPromoDisabled ? 'disabled' : ''}`}
                        disabled={copyPromoDisabled}
                        onClick={() => {
                            setIsCopyMode(!isCopyMode);
                        }}
                    >
                        {isCopyMode ? 'Cancel Copy' : 'Copy Promotion'}
                    </Button>
                </ComponentAccess>
                <SearchBar data={searchBarDataComponents} inputHandler={inputHandler} />
            </Box>
            <ListAssignedPromotions
                input={inputText}
                data={campaignData}
                createDisabled={addPromoDisabled}
                isCopyMode={isCopyMode}
                setIsCopyMode={setIsCopyMode}
                campaignConfigsData={assignedPromotionsData}
                setCampaignConfigsData={setAssignedPromotionsData}
            />
        </Box>
    );
}
export { AssignedPromotionsInfo }
